define(
({
  "load_error": "Fout tijdens laden",
  "description": "Een verzoek is niet correct voltooid. Zorg ervoor dat uw bestelling is opgeslagen en ververs daarna deze pagina."
})
);
